import * as React from 'react';
import * as Yup from 'yup';

import { Button, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import * as formatDate from 'date-fns/format';

import { FormErrorFeedback } from 'common/components/form/FormErrorFeedback';
import { FormMoneyInput } from 'common/components/form/FormMoneyInput';
import { Formik, FormikProps } from 'formik';
import { Transaction } from 'common/api/models/Transaction';
import { toFormGroupStyle } from 'common/utils/form';
import { FormInput } from 'common/components/form/FormInput';

export interface Payment {
  type: Transaction.Type;
  amount: number;
  date: string;
  fee?: number;
  checkNumber: string;
}
interface PaymentDialogProps {
  isOpen: boolean;
  onSave: (saved: Payment) => void;
  onCancel: () => void;
  error?: string;
  title?: string;
  saveLabel?: string;
}
class PaymentValues {
  type = '';
  amount = '';
  date = '';
  fee = '';
  checkNumber = '';
}

export class PaymentDialog extends React.Component<PaymentDialogProps> {
  validationSchema = Yup.object().shape({
    amount: Yup.number().required('Required'),
    fee: Yup.number(),
    checkNumber: Yup.string().required('Required'),
  });

  initialValues() {
    return {
      type: 'CHECK',
      date: formatDate(new Date(), 'YYYY-MM-DD'),
      amount: '',
      fee: '',
      checkNumber: '',
    };
  }

  handleSubmit = (values: PaymentValues) => {
    if (values.type === 'CHECK') {
      this.props.onSave({
        type: Transaction.Type.CHECK,
        date: values.date,
        amount: Number(values.amount),
        checkNumber: values.checkNumber,
      });
    } else {
      this.props.onSave({
        type: Transaction.Type.WIRE,
        date: values.date,
        amount: Number(values.amount),
        fee: Number(values.fee ? values.fee : 0),
        checkNumber: values.checkNumber,
      });
    }
  };

  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          validationSchema={this.validationSchema}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<PaymentValues>) => (
            <form onSubmit={form.handleSubmit} data-testid="paymentDialogForm">
              <ModalHeader toggle={this.props.onCancel}>
                {this.props.title ? this.props.title : 'Process Payment'}
              </ModalHeader>
              <ModalBody>
                <FormGroup color={toFormGroupStyle('type', form)}>
                  <div className="btn-group">
                    <label>
                      <input
                        type="radio"
                        name="type"
                        value="CHECK"
                        checked={form.values.type === 'CHECK'}
                        onChange={form.handleChange}
                      />{' '}
                      Check
                    </label>
                    <label style={{ marginLeft: 20 }}>
                      <input
                        type="radio"
                        name="type"
                        value="WIRE"
                        checked={form.values.type === 'WIRE'}
                        onChange={form.handleChange}
                      />{' '}
                      Wire
                    </label>
                  </div>
                  <FormErrorFeedback form={form} field="amount" />
                </FormGroup>
                <FormMoneyInput id="amount" name="amount" label="Amount" />
                <FormInput label="Date" type="date" name="date" id="date" />

                {form.values.type === 'WIRE' && <FormMoneyInput id="fee" name="fee" label="Wire Fee" />}
                <FormInput
                  label={`${form.values.type === 'CHECK' ? 'Check' : 'Wire'} Number`}
                  name="checkNumber"
                  id="checkNumber"
                />
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    {this.props.saveLabel ? this.props.saveLabel : 'Save'}
                  </Button>
                </div>
              </ModalFooter>
              {form.error && <div className="alert alert-danger">{form.error}</div>}
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orders/PaymentDialog.tsx